var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 63,
    viewBox: "0 0 70 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5259 0.882812C20.9098 4.41696 13.6679 6.97927 5.27744 7.82266C4.9834 7.85222 0.270412 8.3159 0.766534 8.86364C2.35762 10.6203 3.56763 11.8489 4.58345 14.0685C5.70264 16.514 7.01436 19.0969 7.70638 21.7024C8.29283 23.9104 9.13563 26.0267 9.44135 28.2952C9.93346 31.9469 9.44135 35.7244 9.44135 39.399C9.44135 42.8301 9.32591 46.3976 9.78834 49.8087C10.1797 52.6954 10.7749 55.5338 10.8293 58.4836C10.8317 58.6106 11.0227 62.4263 11.5233 61.2595C12.2721 59.5142 12.7332 58.6232 14.2992 57.4426C17.8672 54.7528 21.6985 53.2948 26.097 52.5847C30.42 51.8868 34.205 51.5437 38.5887 51.5437C41.0575 51.5437 43.7543 51.5985 46.2225 51.5437C46.875 51.5292 46.5695 50.2338 46.5695 49.8087",
    stroke: "#FB7C51",
    strokeWidth: 1.15296,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8728 0.882812C29.8301 4.16882 31.7072 7.10891 33.0367 10.2516C34.7219 14.2352 35.9333 18.1817 37.8946 22.0494C39.1873 24.5985 39.8576 27.7509 41.0175 30.3772C42.1798 33.0088 42.7722 35.9134 43.4465 38.705C43.8593 40.4143 43.6728 42.1942 44.1405 43.9099C44.4176 44.9265 44.7798 46.0572 45.1814 47.0328C45.4981 47.8019 46.1275 48.4247 46.5694 49.1148C46.6697 49.2714 46.6732 49.6283 46.5694 49.8087",
    stroke: "#FB7C51",
    strokeWidth: 1.15296,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4656 16.1498C35.7499 12.3174 35.408 8.18694 35.1186 4.3521C35.0939 4.02516 34.9396 2.47719 35.4656 2.27015C35.7672 2.15142 36.7452 1.92425 36.8536 1.92316C38.8231 1.90329 40.7829 1.92316 42.7525 1.92316C47.5942 1.92316 52.4844 1.92316 57.3261 1.92316C59.6505 1.92316 62.2876 1.67418 64.613 1.92316C66.679 2.14436 66.8115 2.55965 67.0419 4.6991C67.2292 6.4375 67.8849 8.15538 68.0829 9.90398C68.3546 12.3035 68.0829 14.7808 68.0829 17.1908C68.0829 24.2592 68.0829 31.289 68.0829 38.3574C68.0829 41.1132 68.0829 43.9293 68.0829 46.6852C68.0829 47.2118 67.742 47.9801 68.0829 48.4201C68.6788 49.1891 68.6418 50.6332 68.7769 51.5431C68.8077 51.7507 69.5781 54.1612 68.7769 53.625C67.1832 52.5585 64.7025 52.0685 62.878 51.5431C60.3007 50.8009 58.2599 50.5021 55.5912 50.5021C53.0937 50.5021 50.4549 50.5021 47.9573 50.5021C46.8327 50.5021 47.0583 52.0497 46.0489 51.5431",
    stroke: "#FB7C51",
    strokeWidth: 1.15296,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8703 17.5383C11.9625 18.9757 12.5511 21.7022 14.2992 21.7022C14.804 21.7022 16.0342 21.6857 16.0342 21.0082C16.0342 19.4726 15.4343 18.3018 14.9932 16.8443C14.7957 16.1916 11.5556 17.2297 11.1763 17.5383",
    stroke: "#FB7C51",
    strokeWidth: 1.15296,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3236 13.2385C40.4158 14.6759 41.0045 17.4024 42.7526 17.4024C43.2574 17.4024 44.4875 17.3859 44.4875 16.7084C44.4875 15.1728 43.8876 14.002 43.4466 12.5445C43.249 11.8918 40.009 12.9299 39.6296 13.2385",
    stroke: "#FB7C51",
    strokeWidth: 1.15296,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6052 28.9891C19.6006 27.2625 25.4475 25.8236 31.6488 25.1722C32.4985 25.0829 33.583 25.1659 34.4248 24.8252",
    stroke: "#FB7C51",
    strokeWidth: 1.15296,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8101 48.4205C23.4365 46.9421 27.8709 46.6855 32.6898 46.6855",
    stroke: "#FB7C51",
    strokeWidth: 1.15296,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9355 23.7842H62.184",
    stroke: "#FB7C51",
    strokeWidth: 1.15296,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6707 28.2949C43.1002 28.4049 45.5287 28.5236 47.9575 28.6419",
    stroke: "#FB7C51",
    strokeWidth: 1.15296,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7935 42.1743C49.3359 42.1743 55.4348 41.2246 60.7961 42.8683",
    stroke: "#FB7C51",
    strokeWidth: 1.15296,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedIcon);
export default __webpack_public_path__ + "static/media/uploadedIcon.790521ce2ad323b518ee386d5dc798e9.svg";
export { ForwardRef as ReactComponent };